import React, { useState } from "react";

export default function Grading({ data }) {
  const [selectedLot, setSelectedLot] = useState("");
  const [grade, setGrade] = useState("");

  const lots = data?.lots || [];

  return (
    <div>
      <h2 className="text-xl text-yellow-200 mb-4">Grading & Quality</h2>

      {/* SELECT LOT */}
      <select
        value={selectedLot}
        onChange={(e) => setSelectedLot(e.target.value)}
        className="p-2 text-black mb-3 w-full"
      >
        <option value="">Select Lot</option>
        {lots.map((lot) => (
          <option key={lot.id} value={lot.id}>
            {lot.id} - {lot.crop}
          </option>
        ))}
      </select>

      {/* GRADE INPUT */}
      <select
        value={grade}
        onChange={(e) => setGrade(e.target.value)}
        className="p-2 text-black mb-3 w-full"
      >
        <option value="">Select Grade</option>
        <option value="A">Grade A</option>
        <option value="B">Grade B</option>
        <option value="C">Grade C</option>
      </select>

      <button className="bg-green-600 px-4 py-2 rounded">
        Assign Grade
      </button>

      {/* DISPLAY */}
      {selectedLot && (
        <div className="mt-4 bg-gray-800 p-3 rounded">
          <p>Lot: {selectedLot}</p>
          <p>Assigned Grade: {grade || "Not Assigned"}</p>
        </div>
      )}
    </div>
  );
}